type DocumentLang = 'ru' | 'en' | 'be' | 'kk';

const getDocumentLang = (): DocumentLang => {
  const currentLang = window.navigator.language;
  const defaultLang = 'ru';
  const supportedLangs: Record<DocumentLang, RegExp> = {
    ru: /ru/,
    en: /en/,
    be: /be/,
    kk: /(kz|kk)/,
  };

  const availableLangs = Object.keys(supportedLangs) as Array<keyof typeof supportedLangs>;
  const foundLang = availableLangs.find((lang) => currentLang.match(supportedLangs[lang])) || defaultLang;
  return foundLang;
};

const VkTranslationsLangCode = {
  ru: 'ru',
  en: 'en',
  be: 'be',
  kk: 'kz',
} as const;

export const getTranslationsLang = () => VkTranslationsLangCode[getDocumentLang()];
